import React, {Component} from 'react';
import {connect} from 'react-redux';
import Admin from '../components/admin';
import {Redirect} from 'react-router-dom'
import axios from '../axios'

import Alert from '../components/UI/Alert';
import Success from '../components/UI/Success';

import * as actions from '../store/actions/index'

class AdminPage extends Component {
    state = {
        codeValue: '',
        pesoValue: null,
        alturaValue: null,
        departmentValue: null,
        ageValue: null,
        genderValue: null,
        maritalValue: null,
        academicValue: null,
        smokersVValue: null,
        smokersFValue: null,
        smokersTValue: null,
        smokersAValue: null,
        healthOValue: null,
        //22-05
        sleepOValue: null,
        sleepValue: null,
        //
        chronicOValue: [],
        mealValue: null,
        breakfastValue: null,
        fruitValue: null,
        vegetableValue: null,
        sodaValue: null,
        fastFValue: null,
        alcohol: null,
        beer: null,
        wine: null,
        spiritDrinks: null,
        walking_cyclingValue: null,
        sistValue: null,
        distValue: null,
        pulseValue: null,
        uricValue: null,
        glucoseValue: null,
        colestherolValue: null,
        chronicOption: null,
        alcoholOption: null,
        medOption: null,
        medsValue: [],
        medsNValue: null,
        painVValue: null,
        painLValue: null,
        painSValue: null,
        physicalOption: null,
        physicalVValue: [],
        physicalHValue: null,
        spiroOption: null,
        spiroValue: [],
        visualOption: null,
        visualValue: [],
        auditoryOption: null,
        auditoryValue: [],
        ecgOption: null,
        ecgValue: [],
        eritrogramOption: null,
        eritrogramValue: [],
        leukogramOption: null,
        leukogramValue: [],
        redirect: false,
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.onFetchDepartments();
        this.props.onFetchAges();
        this.props.onFetchGenders();
        this.props.onFetchMarital();
        this.props.onFetchAcademic();
        this.props.onFetchSmokersV();
        this.props.onFetchSmokersF();
        this.props.onFetchSmokersA();
        this.props.onFetchSmokersT();
        this.props.onFetchHealthO();

        //22-05
        this.props.onFetchSleepO();
        //
        this.props.onFetchChronicO();
        this.props.onFetchMeals();
        this.props.onFetchBreakfast();
        this.props.onFetchFruits();
        this.props.onFetchVegetables();
        this.props.onFetchSodas();
        this.props.onFetchFastF();
        this.props.onFetchWalking_cycling();
        this.props.onFetchMeds();
        this.props.onFetchPainV();
        this.props.onFetchPainL();
        this.props.onFetchPainS();
        this.props.onFetchMeals();
        this.props.onFetchPhysicalV();
        this.props.onFetchPhysicalH();
        this.props.onFetchSpiro();
        this.props.onFetchVisual();
        this.props.onFetchAuditory();
        this.props.onFetchEcg();
        this.props.onFetchEritrogram();
        this.props.onFetchLeukogram();

        console.log(this.props.status);
        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/admin/checkadmin`, {headers: {"Authorization": token}})
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    componentWillUnmount() {
        this.props.inserFormRemoveMessage();
        console.log("componentWillUnmount");
    }

    submitHandler = async (event) => {
        event.preventDefault();
        this.setState({formLoading: true});
        let result = null;

        window.scrollTo(0, 0);

        result = await this.props.onInsertForm(this.state.codeValue, this.state.genderValue, this.state.pesoValue, this.state.alturaValue,
                                this.state.departmentValue, this.state.ageValue, this.state.maritalValue, this.state.academicValue,
                                this.state.smokersVValue, this.state.smokersFValue, this.state.smokersAValue, this.state.smokersTValue,
                                this.state.healthOValue, this.state.sleepOValue, this.state.sleepValue, this.state.chronicOValue,
                                this.state.mealValue, this.state.breakfastValue, this.state.fruitValue, this.state.vegetableValue,
                                this.state.sodaValue, this.state.fastFValue, this.state.walking_cyclingValue, this.state.sistValue,
                                this.state.distValue, this.state.pulseValue, this.state.uricValue, this.state.glucoseValue,
                                this.state.colestherolValue, this.state.medsValue, this.state.medsNValue, this.state.painVValue,
                                this.state.painLValue, this.state.painSValue, this.state.physicalVValue, this.state.physicalHValue,
                                this.state.spiroOption, this.state.visualOption, this.state.auditoryOption, this.state.ecgOption,
                                this.state.eritrogramOption, this.state.leukogramOption, this.state.chronicOption, this.state.medOption,
                                this.state.physicalOption, this.state.spiroValue, this.state.visualValue, this.state.auditoryValue,
                                this.state.ecgValue, this.state.eritrogramValue, this.state.leukogramValue, this.state.alcoholOption,
                                this.state.beer, this.state.wine, this.state.spiritDrinks);

        if(result != null){
            if (result){
                this.resetForm();
            }
        }
    };
    resetForm = () =>{
        document.getElementById("quest").reset();
        this.setState({
            codeValue: '',
            painVValue: null,
            medOption: null,
            chronicOption: null,
            smokersVValue: null,
            alcoholOption: null,
            physicalOption: null,
            spiroOption: null,
            visualOption: null,
            auditoryOption: null,
            ecgOption: null,
            eritrogramOption: null,
            leukogramOption:null,
            spiroValue:[],
            visualValue:[],
            auditoryValue:[],
            ecgValue:[],
            eritrogramValue:[],
            leukogramValue:[]
        })
    };

    codeChangeHandler = (event) => {
        this.setState({codeValue: event.target.value});
    };
    pesoChangeHandler = (event) => {
        this.setState({pesoValue: event.target.value})
    };
    alturaChangeHandler = (event) => {
        this.setState({alturaValue: event.target.value})
    };

    sleepChangehandler = (event) => {
        this.setState({sleepValue: event.target.value})
    };

    depChangeHandler = (event) => {
        this.setState({departmentValue: event.target.value});
        if (event.target.value === '') {
            this.setState({departmentValue: null})
        }
    };
    ageChangeHandler = (event) => {
        this.setState({ageValue: event.target.value});
        if (event.target.value === '') {
            this.setState({ageValue: null})
        }
    };
    genderChangeHandler = (event) => {
        this.setState({
            genderValue: event.target.value,
        })
    };
    maritalChangeHandler = (event) => {
        this.setState({maritalValue: event.target.value});
        if (event.target.value === '') {
            this.setState({maritalValue: null})
        }
    };
    academicChangeHandler = (event) => {
        this.setState({academicValue: event.target.value});
        if (event.target.value === '') {
            this.setState({academicValue: null})
        }
    };
    smokersVChangeHandler = (event) => {
        this.setState({smokersVValue: event.target.value});
        if (event.target.value === '') {
            this.setState({smokersVValue: null})
        }
    };
    smokersFChangeHandler = (event) => {
        this.setState({smokersFValue: event.target.value});
        if (event.target.value === '') {
            this.setState({smokersFValue: null})
        }
    };

    smokersTChangeHandler = (event) => {
        this.setState({smokersTValue: event.target.value});
        if (event.target.value === '') {
            this.setState({smokersTValue: null})
        }
    };

    smokersAChangeHandler = (event) => {
        this.setState({smokersAValue: event.target.value});
        if (event.target.value === '') {
            this.setState({smokersAValue: null})
        }
    };
    healthOChangeHandler = (event) => {
        this.setState({healthOValue: event.target.value});
        if (event.target.value === '') {
            this.setState({healthOValue: null})
        }
    };

    //22-05
    sleepOChangeHandler = (event) => {
        this.setState({sleepOValue: event.target.value});
        if (event.target.value === '') {
            this.setState({sleepOValue: null})
        }
    };

    //chronicOChange

    chronicOChangeHandler = (e) => {
        const optionsC = this.state.chronicOValue;
        let index;


        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsC.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            index = optionsC.indexOf(+e.target.value);
            optionsC.splice(index, 1)
        }
        console.log("optionsC--->" + optionsC);
        // update the state with the new array of options
        this.setState({
            chronicOValue: optionsC
        })
    };

    onChronicChangeHandler = (event) => {
        this.setState({chronicOption: event.target.value});
    };


    mealsChangeHandler = (event) => {
        this.setState({
            mealValue: event.target.value,
            radioMeal: true
        });
        if (event.target.value === '') {
            this.setState({mealValue: null})
        }
    };
    breakfastChangeHandler = (event) => {
        this.setState({
            breakfastValue: event.target.value,
            /*radioBreakfast: true*/
        });
        if (event.target.value === '') {
            this.setState({breakfastValue: null})
        }
    };
    fruitChangeHandler = (event) => {
        this.setState({
            fruitValue: event.target.value,
            /*radiofruit: true*/
        });
        if (event.target.value === '') {
            this.setState({fruitValue: null})
        }
    };
    vegetableChangeHandler = (event) => {
        this.setState({
            vegetableValue: event.target.value,
           /* radioVegetables: true*/
        });
        if (event.target.value === '') {
            this.setState({vegetableValue: null})
        }
    };
    sodaChangeHandler = (event) => {
        this.setState({
            sodaValue: event.target.value,
           /* radioSodas: true*/
        });
        if (event.target.value === '') {
            this.setState({sodaValue: null})
        }
    };
    fastFChangeHandler = (event) => {
        this.setState({
            fastFValue: event.target.value,
           /* radioFastFood: true*/
        });
        if (event.target.value === '') {
            this.setState({fastFValue: null})
        }
    };

    onAlcoholChangeHandler = (event) => {
        if (event.target.value === "null") {
            this.setState({alcoholOption: null});
        } else {
            this.setState({
                alcoholOption: event.target.value,
                /*radioAlcohol: true*/
            });
        }
        if (event.target.value === "0" || event.target.value === "null") {
            this.setState({beer: null, wine: null, spiritDrinks: null});
        }
    };

    beerChangeHandler = (event) => {
        if (event.target.value === "null") {
            this.setState({beer: null});
        } else {
            this.setState({beer: event.target.value});
        }
    };

    wineChangeHandler = (event) => {
        if (event.target.value === "null") {
            this.setState({wine: null});
        } else {
            this.setState({wine: event.target.value});
        }
    };

    spiritDrinksChangeHandler = (event) => {
        if (event.target.value === "null") {
            this.setState({spiritDrinks: null});
        } else {
            this.setState({spiritDrinks: event.target.value});
        }
    };

    walking_cyclingChangeHandler = (event) => {
        this.setState({walking_cyclingValue: event.target.value});
        if (event.target.value === '') {
            this.setState({walking_cyclingValue: null})
        }
    };
    sistChangeHandler = (event) => {
        this.setState({sistValue: event.target.value});
        if (event.target.value === '') {
            this.setState({sistValue: null})
        }
    };
    distChangeHandler = (event) => {
        this.setState({distValue: event.target.value});
        if (event.target.value === '') {
            this.setState({distValue: null})
        }
    };
    pulseChangeHandler = (event) => {
        this.setState({pulseValue: event.target.value});
        if (event.target.value === '') {
            this.setState({pulseValue: null})
        }
    };
    uricChangeHandler = (event) => {
        this.setState({uricValue: event.target.value});
        if (event.target.value === '') {
            this.setState({uricValue: null})
        }
    };
    glucoseChangeHandler = (event) => {
        this.setState({glucoseValue: event.target.value});
        if (event.target.value === '') {
            this.setState({glucoseValue: null})
        }
    };
    colestherolChangeHandler = (event) => {
        this.setState({colestherolValue: event.target.value});
        if (event.target.value === '') {
            this.setState({colestherolValue: null})
        }
    };

    //meds
    onMedChangeHandler = (event) => {
        this.setState({medOption: event.target.value});
        //console.log("onMedChangeHandler---->> " + event.target.value);
        //console.log("this.medOption---->> " + this.medOption);
    };
    medsChangeHandler = (event) => {
        const optionsM = this.state.medsValue;
        let indexM;

        // check if the check box is checked or unchecked
        if (event.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsM.push(+event.target.value);
            //console.log("event.target.checked---->> " + event.target.checked);
            //console.log("optionsM----->> " + optionsM);
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexM = optionsM.indexOf(+event.target.value);
            optionsM.splice(indexM, 1);
        }
        console.log("optionsM----> " + optionsM);

        // update the state with the new array of options
        this.setState({medsValue: optionsM})
    };
    medsNChangeHandler = (event) => {
        this.setState({medsNValue: event.target.value});

    };
    //pain
    //Pain Value
    painVChangeHandler = (event) => {
        this.setState({painVValue: event.target.value});
    };

    //Local Pain
    painLChangeHandler = (event) => {
        this.setState({painLValue: event.target.value});
        if (event.target.value === '') {
            this.setState({painLValue: null})
        }
    };
    //Scale Pain
    painSChangeHandler = (event) => {
        this.setState({painSValue: event.target.value})
    };
    /*
        averageMealsChangeHandler = (event) => {
            this.setState({averageMealsValue: event.target.value});
        };*/
    onPhysicalChangeHandler = (event) => {
        this.setState({physicalOption: event.target.value});
        if (event.target.value === '') {
            this.setState({physicalOption: null})
        }
    };

    physicalVChangeHandler = (e) => {
        const optionsPhysical = this.state.physicalVValue;
        let indexPhysical;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsPhysical.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexPhysical = optionsPhysical.indexOf(+e.target.value);
            optionsPhysical.splice(indexPhysical, 1)
        }
        console.log("physicalVValue---->>" + this.state.physicalVValue);
        // update the state with the new array of options
        this.setState({physicalVValue: optionsPhysical})
    };

    physicalHChangeHandler = (event) => {
        this.setState({physicalHValue: event.target.value});
    };

    onSpiroChangeHandler = (event) => {
        this.setState({spiroOption: event.target.value});
        if (event.target.value === '') {
            this.setState({spiroOption: null})
        }
    };
    spiroChangeHandler = (e) =>  {
        const optionsSpiro = this.state.spiroValue;
        let indexSpiro;


        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsSpiro.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexSpiro = optionsSpiro.indexOf(+e.target.value);
            optionsSpiro.splice(indexSpiro, 1)
        }
        console.log("optionsSpiro---->" + optionsSpiro);
        // update the state with the new array of options
        this.setState({spiroValue: optionsSpiro})
    };/*{


        this.setState({spiroValue: event.target.value});
    };*/

    onVisualChangeHandler = (event) => {
        this.setState({visualOption: event.target.value});
    };
    visualChangeHandler = (e) => {
        const optionsVisual = this.state.visualValue;
        let indexVisual;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsVisual.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexVisual = optionsVisual.indexOf(+e.target.value);
            optionsVisual.splice(indexVisual, 1)
        }

        // update the state with the new array of options
        this.setState({visualValue: optionsVisual})
    };
       /* this.setState({visualValue: event.target.value});
    };*/

    onAuditoryChangeHandler = (event) => {
        this.setState({auditoryOption: event.target.value});
    };
    auditoryChangeHandler = (e) => {
        const optionsAuditory = this.state.auditoryValue;
        let indexAuditory;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsAuditory.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexAuditory = optionsAuditory.indexOf(+e.target.value);
            optionsAuditory.splice(indexAuditory, 1)
        }

        // update the state with the new array of options
        this.setState({auditoryValue: optionsAuditory});
    };

    onEcgChangeHandler = (event) => {
        this.setState({ecgOption: event.target.value});
    };
    ecgChangeHandler = (e) => {
        const optionsEcg = this.state.ecgValue;
        let indexEcg;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsEcg.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexEcg = optionsEcg.indexOf(+e.target.value);
            optionsEcg.splice(indexEcg, 1)
        }
        // update the state with the new array of options
        this.setState({ecgValue: optionsEcg});

        /*this.setState({ecgValue: event.target.value});*/
    };
    onEritrogramChangeHandler = (event) => {
        this.setState({eritrogramOption: event.target.value});
    };
    eritrogramChangeHandler = (e) => {
        const optionsEritogram = this.state.eritrogramValue;
        let indexEritogram;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsEritogram.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexEritogram = optionsEritogram.indexOf(+e.target.value);
            optionsEritogram.splice(indexEritogram, 1)
        }
        // update the state with the new array of options
        this.setState({eritogramValue: optionsEritogram});

        /*this.setState({eritogramValue: event.target.value});*/
    };
    onLeukogramChangeHandler = (event) => {
        this.setState({leukogramOption: event.target.value});
    };
    leukogramChangeHandler = (e) => {
        const optionsLeukogram = this.state.leukogramValue;
        let indexLeukogram;

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            optionsLeukogram.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            indexLeukogram = optionsLeukogram.indexOf(+e.target.value);
            optionsLeukogram.splice(indexLeukogram, 1)
        }
        // update the state with the new array of options
        this.setState({leukogramValue: optionsLeukogram});

        /*this.setState({leukogramValue: event.target.value});*/
    };

    render() {
        let depSelect = this.props.departments.map(department => {
            return (
                <option value={department.id_departments_services_schools}
                        key={department.id_departments_services_schools}>{department.value}</option>
            )
        });
        let ageSelect = this.props.ages.map(ages => {
            return (
                <option value={ages.id_ages} key={ages.id_ages}>{ages.value}</option>
            )
        });
        let genderSelect = this.props.genders.map(genders => {
            /*  return (
                  <option value={genders.id_genders} key={genders.id_genders}>{genders.value}</option>
              )
              */
            return (
                <div className="form-check form-check-inline" key={genders.id_genders}>
                    <input className="form-check-input" type="radio" name={"inlineRadio_genders"} id={"inlineRadio" + genders.id_genders}
                           value={genders.id_genders} checked={this.state.radioGender} onChange={this.genderChangeHandler}/>
                    <label className="form-check-label" htmlFor={"inlineRadio" + genders.id_genders}>{genders.value}</label>
                </div>
            )
        });
        let maritalSelect = this.props.marital.map(marital => {
            return (
                <option value={marital.id_marital_status} key={marital.id_marital_status}>{marital.value}</option>
            )
        });
        let academicSelect = this.props.academic.map(academic => {
            return (
                <option value={academic.id_academic_levels} key={academic.id_academic_levels}>{academic.value}</option>
            )
        });
        let smokersVSelect = this.props.smokersV.map(smokersV => {
            return (
                <option value={smokersV.id_smokers_value} key={smokersV.id_smokers_value}>{smokersV.value}</option>
            )
        });
        let smokersFSelect = this.props.smokersF.map(smokersF => {
            return (
                <option value={smokersF.id_frequencies} key={smokersF.id_frequencies}>{smokersF.value}</option>
            )
        });
        let smokersTSelect = this.props.smokersT.map(smokersT => {
            return(
                <option value = {smokersT.id_smokers_type} key={smokersT.id_smokers_type}>{smokersT.value}</option>
            )
        });
        let smokersASelect = this.props.smokersA.map(smokersA => {
            return (
                <option value={smokersA.id_average_daily_smokes}
                        key={smokersA.id_average_daily_smokes}>{smokersA.value}</option>
            )
        });
        let healthOSelect = this.props.healthO.map(healthO => {
            return (
                <option value={healthO.id_health_opinions} key={healthO.id_health_opinions}>{healthO.value}</option>
            )
        });
        let sleepOSelect = this.props.sleepO.map(sleepO => {
            return (
                <option value={sleepO.id_sleep_opinions} key={sleepO.id_sleep_opinions}>{sleepO.value}</option>
            )
        });
        let chronicOSelect = this.props.chronicO.map(chronicO => {
            return (
                /*
                <option value={chronicO.id_chronic_diseases_value} key={chronicO.id_chronic_diseases_value}>{chronicO.value}</option>
*/

                /*<div className="form-group">
                 <select defaultValue="Indique quais" onChange={props.chronicOSelected}>
                 <option disabled><label className="form-text text-muted mb-3">Indique quais</label></option>
                 {props.chronicOSelect}
                 </select>
                 </div>*/
                <div className="form-check" key={chronicO.id_chronic_diseases_value}>
                    <input type="checkbox" onChange={this.chronicOChangeHandler} name="vehicle"
                           className="form-check-input" key={chronicO.id_chronic_diseases_value}
                           id={"defaultCheck" + chronicO.id_chronic_diseases_value}
                           value={chronicO.id_chronic_diseases_value}/><label className="form-check-label"
                           htmlFor={"defaultCheck" + chronicO.id_chronic_diseases_value}>{chronicO.id_chronic_diseases_value}. {chronicO.value}</label>
                </div>
            )
        });
        let mealSelect = this.props.meals.map(meals => {
            /*return (
                <option value={meals.id_meals} key={meals.id_meals}>{meals.value}</option>
            )*/


            return (
                <div className="form-check form-check-inline" key={meals.id_meals}>
                    <input className="form-check-input" type="radio"
                           name="inlineRadioOptions_meals"
                           id={"inlineRadio_meals"+ meals.id_meals}
                           value={meals.id_meals}
                           /*checked={this.state.radioMeal}*/
                           onChange={this.mealsChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_meals">{meals.value}</label>

                </div>
            )
        });
        let breakfastSelect = this.props.breakfast.map(breakfast => {
            /*            return (
                            <option value={breakfast.id_breakfast} key={breakfast.id_breakfast}>{breakfast.value}</option>
                        )*/

            return (<div className="form-check form-check-inline" key={breakfast.id_breakfast}>
                    <input className="form-check-input"
                           type="radio"
                           name="inlineRadioOptions_breakFast"
                           id={"inlineRadio_breakFast" + breakfast.id_breakfast}
                           value={breakfast.id_breakfast}
                           /*checked={this.state.radioBreakFast}*/
                           onChange={this.breakfastChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_breakFast">{breakfast.value}</label>

                </div>
            )
        });
        let fruitSelect = this.props.fruits.map(fruits => {
            /*            return (
                            <option value={fruits.id_fruits} key={fruits.id_fruits}>{fruits.value}</option>
                        )*/
            return (<div className="form-check form-check-inline" key={fruits.id_fruits}>
                    <input className="form-check-input" type="radio"
                           name="inlineRadioOptions_fruits"
                           id={"inlineRadio_fruits" + fruits.id_fruits}
                           value={fruits.id_fruits}
                           /*checked={this.state.radioFruit}*/
                           onChange={this.fruitChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_breakFast">{fruits.value}</label>

                </div>
            )

        });
        let vegetableSelect = this.props.vegetables.map(vegetables => {
            /* return (
                 <option value={vegetables.id_vegetables} key={vegetables.id_vegetables}>{vegetables.value}</option>
             )*/
            return (<div className="form-check form-check-inline" key={vegetables.id_vegetables}>
                    <input className="form-check-input"
                           type="radio"
                           name="inlineRadioOptions_vegetables"
                           id={"inlineRadio_vegetables" + vegetables.id_vegetables}
                           value={vegetables.id_vegetables}
                           /*checked={this.state.radioVegetables}*/
                           onChange={this.vegetableChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_vegetables">{vegetables.value}</label>
                </div>
            )

        });
        let sodaSelect = this.props.sodas.map(sodas => {
            /*            return (
                            <option value={sodas.id_sodas} key={sodas.id_sodas}>{sodas.value}</option>
                        )*/
            return (<div className="form-check form-check-inline" key={sodas.id_sodas}>
                    <input className="form-check-input"
                           type="radio"
                           name="inlineRadioOptions_soda"
                           id={"inlineRadio_soda" + sodas.id_sodas}
                           value={sodas.id_sodas}
                           checked={this.state.radioSodas}
                           onChange={this.sodaChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_soda">{sodas.value}</label>
                </div>
            )

        });
        let fastFSelect = this.props.fastF.map(fastF => {
            /*            return (
                            <option value={fastF.id_fast_food} key={fastF.id_fast_food}>{fastF.value}</option>
                        )*/
            return (<div className="form-check form-check-inline" key={fastF.id_fast_food}>
                    <input className="form-check-input" type="radio"
                           name="inlineRadioOptions_fastF"
                           id={"inlineRadio_fastF" + fastF.id_fast_food}
                           value={fastF.id_fast_food}
                          /* checked={this.state.radioFastFood}*/
                           onChange={this.fastFChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio_soda">{fastF.value}</label>
                </div>
            )
        });
        let walking_cyclingSelect = this.props.walking_cycling.map(walking_cycling => {
            return (
                <option value={walking_cycling.id_walking_cycling}
                        key={walking_cycling.id_walking_cycling}>{walking_cycling.value}</option>
            )
        });
        let medsSelect = this.props.meds.map(meds => {
            //console.log("medsvalue--->> " + meds.value);
            return (
                <div className="form-check" key={meds.id_takes_meds_value}>
                    <input type="checkbox" onChange={this.medsChangeHandler} name="meds" className="form-check-input"
                           key={meds.id_takes_meds_value} id={"defaultCheckMed" + meds.id_takes_meds_value}
                           value={meds.id_takes_meds_value}/>
                           <label className="form-check-label" htmlFor={"defaultCheckMed" + meds.id_takes_meds_value}>
                               {meds.id_takes_meds_value}.{meds.value}
                           </label>
                </div>
            )
        });
        let painVSelect = this.props.painV.map(painV => {
            return (
                <div className="form-check form-check-inline" key={painV.id_pain_value}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptionsPainV"
                           id={"inlineRadioPainV" + painV.id_pain_value} value={painV.id_pain_value}
                           onChange={this.painVChangeHandler}/>
                    <label className="form-check-label" htmlFor={"inlineRadioPainV" + painV.id_pain_value}>{painV.value}</label>
                </div>

/*
*                <div className="form-check form-check-inline" key={painV.id_pain_value}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio2"
                           value={painV.id_pain_value} onChange={this.painVChangeHandler} />
                    <label className="form-check-label" htmlFor="inlineRadio2">{painV.value}</label>
                </div>


                <div className="form-check">
                    <input type="checkbox" onChange={this.painVChangeHandler} name="painV" className="form-check-input" key={pain                     .id_pain_value} id={"defaultCheckMed"+painV.id_pain_value} value={painV.id_pain_value}/><label className="form-check-label" htmlFor={"defaultCheckMed"+painV.id_pain_value}>{painV.value}</label>
                </div>
*/
            )
        });
        let painLSelect = this.props.painL.map(painL => {
            return (
                <div className="form-check" key={painL.id_local_pain}>
                    <input type="checkbox" onChange={this.painLChangeHandler} name="localPain"
                           className="form-check-input"
                           key={painL.id_local_pain} id={"defaultCheckMed" + painL.id_local_pain}
                           value={painL.id_local_pain}/><label className="form-check-label"
                           htmlFor={"defaultCheckMed" + painL.id_local_pain}>{painL.id_local_pain}. {painL.value}</label>
                </div>
            )
        });
        let painSSelect = this.props.painS.map(painS => {
            return (<div className="form-check form-check-inline" key={painS.id_pain_scale}>
                    <input className="form-check-input" type="radio" name={"inlineRadio" + painS.id_pain_scale} id={"inlineRadio" + painS.id_pain_scale}
                           value={painS.id_pain_scale} onChange={this.painSChangeHandler}/>
                    <label className="form-check-label" htmlFor={"inlineRadio" + painS.id_pain_scale}>{painS.value}</label>

                </div>
            )
        });
        let physicalVSelect = this.props.physicalV.map(physicalV => {
            return (
               /* <option value={physicalV.id_physical_activity_value} key={physicalV.id_physical_activity_value}>{physicalV.value}</option>*/
                <div className="form-check">
                    <input type="checkbox" onChange={this.physicalVChangeHandler} name="physicalValues"
                           className="form-check-input"
                           key={physicalV.id_physical_activity_value}
                           id={"defaultCheckMed" + physicalV.id_physical_activity_value}
                           value={physicalV.id_physical_activity_value}/>
                    <label className="form-check-label" htmlFor={"defaultCheckMed" + physicalV.id_physical_activity_value}>
                        {physicalV.id_physical_activity_value}.{physicalV.value}</label>
                </div>
            )
        });
        let physicalHSelect = this.props.physicalH.map(physicalH => {
            return (
                <option value={physicalH.id_physical_activity_hours} key={physicalH.id_physical_activity_hours}>{physicalH.value}</option>


/*                <div className="form-check form-check-inline" key={physicalH.id_physical_activity_hours}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio2"
                           value={physicalH.id_physical_activity_hours} onChange={this.physicalHChangeHandler}/>
                    <label className="form-check-label" htmlFor="inlineRadio2">{physicalH.value}</label>
                </div>*/


            )
        });
        let spiroSelect = this.props.spiro.map(spiro => {
            return (
                <div className="form-check" key={spiro.id_spirometry_change}>
                    <input type="checkbox" onChange={this.spiroChangeHandler} name="spiro"
                           className="form-check-input" key={spiro.id_spirometry_change}
                           id={"defaultCheck" + spiro.id_spirometry_change}
                           value={spiro.id_spirometry_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" + spiro.id_spirometry_change}>{spiro.id_spirometry_change}. {spiro.value}</label>
                </div>
                /*<option value={spiro.id_spirometry_change} key={spiro.id_spirometry_change}>{spiro.value}</option>*/
            )
        });
        let visualSelect = this.props.visual.map(visual => {
            return (
                <div className="form-check" key={visual.id_visual_screening_change}>
                    <input type="checkbox" onChange={this.visualChangeHandler} name="visual"
                           className="form-check-input" key={visual.id_visual_screening_change}
                           id={"defaultCheck" + visual.id_visual_screening_change}
                           value={visual.id_visual_screening_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" + visual.id_visual_screening_change}>{visual.id_visual_screening_change}. {visual.value}</label>
                </div>
                /*<option value={visual.id_visual_screening_change}
                        key={visual.id_visual_screening_change}>{visual.value}</option>*/
            )
        });
        let auditorySelect = this.props.auditory.map(auditory => {
            return (
                <div className="form-check" key={auditory.id_auditory_screening_change}>
                    <input type="checkbox" onChange={this.auditoryChangeHandler} name="auditoy"
                           className="form-check-input" key={auditory.id_auditory_screening_change}
                           id={"defaultCheck" + auditory.id_auditory_screening_change}
                           value={auditory.id_auditory_screening_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" + auditory.id_auditory_screening_change}>{auditory.id_auditory_screening_change}. {auditory.value}</label>
                </div>
                /*<option value={auditory.id_auditory_screening_change}
                        key={auditory.id_auditory_screening_change}>{auditory.value}</option>*/
            )
        });
        let ecgSelect = this.props.ecg.map(ecg => {
            return (
                <div className="form-check" key={ecg.id_ecg_change}>
                    <input type="checkbox" onChange={this.ecgChangeHandler} name="ecg"
                           className="form-check-input" key={ecg.id_ecg_change}
                           id={"defaultCheck" + ecg.id_ecg_change}
                           value={ecg.id_ecg_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" + ecg.id_ecg_change}>{ecg.id_ecg_change}. {ecg.value}</label>
                </div>
                /*
                <option value={ecg.id_ecg_change} key={ecg.id_ecg_change}>{ecg.value}</option>*/
            )
        });
        let eritrogramSelect = this.props.eritrogram.map(eritrogram => {
            return (
                <div className="form-check" key={eritrogram.id_eritrogram_change}>
                    <input type="checkbox" onChange={this.eritrogramChangeHandler} name="eritrogram"
                           className="form-check-input" key={eritrogram.id_eritrogram_change}
                           id={"defaultCheck" + eritrogram.id_eritrogram_change}
                           value={eritrogram.id_eritrogram_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" +eritrogram.id_eritrogram_change}>{eritrogram.id_eritrogram_change}. {eritrogram.value}</label>
                </div>

/*                <option value={eritrogram.id_eritrogram_change}
                        key={eritrogram.id_eritrogram_change}>{eritrogram.value}</option>*/
            )
        });
        let leukogramSelect = this.props.leukogram.map(leukogram => {
            return (
                <div className="form-check" key={leukogram.id_leukogram_change}>
                    <input type="checkbox" onChange={this.leukogramChangeHandler} name="leukogram"
                           className="form-check-input" key={leukogram.id_leukogram_change}
                           id={"defaultCheck" + leukogram.id_leukogram_change}
                           value={leukogram.id_leukogram_change}/><label className="form-check-label"
                           htmlFor={"defaultCheck" +leukogram.id_leukogram_change}>{leukogram.id_leukogram_change}. {leukogram.value}</label>
                </div>

               /* <option value={leukogram.id_leukogram_change}
                        key={leukogram.id_leukogram_change}>{leukogram.value}</option>*/
            )
        });


        let smokersCenas = this.state.smokersVValue;
        let chronicState = this.state.chronicOption;
        let alcoholState = this.state.alcoholOption;
        let medState = this.state.medOption;
        let physicalState = this.state.physicalOption;

        let spiroState = this.state.spiroOption;
        let visualState = this.state.visualOption;
        let auditoryState = this.state.auditoryOption;
        let ecgState = this.state.ecgOption;
        let eritrogramState = this.state.eritrogramOption;
        let leukogramState = this.state.leukogramOption;

        let message = null;
        if (this.props.status === 0) {
            message = <Alert text={this.props.message}/>
        }
        if (this.props.status === 1) {
            message = <Success text={this.props.message}/>;
        }

        if (this.state.redirect) {
            return <Redirect to="/admin"/>
        }
        return (

            <Admin
                codeValue = {this.state.codeValue}
                codeChange={this.codeChangeHandler}
                pesoChange={this.pesoChangeHandler}
                alturaChange={this.alturaChangeHandler}
                submit={this.submitHandler}
                depSelect={depSelect}
                depSelected={this.depChangeHandler}
                ageSelect={ageSelect}
                ageSelected={this.ageChangeHandler}
                genderSelect={genderSelect}
                genderSelected={this.genderChangeHandler}
                maritalSelect={maritalSelect}
                maritalSelected={this.maritalChangeHandler}
                academicSelect={academicSelect}
                academicSelected={this.academicChangeHandler}
                smokersVSelect={smokersVSelect}
                smokersVSelected={this.smokersVChangeHandler}
                smokersFSelect={smokersFSelect}
                smokersFSelected={this.smokersFChangeHandler}
                smokersASelect={smokersASelect}
                smokersASelected={this.smokersAChangeHandler}
                smokersTSelect = {smokersTSelect}
                smokersTSelected = {this.smokersTChangeHandler}

                healthOSelect={healthOSelect}
                healthOSelected={this.healthOChangeHandler}
                //22-05
                sleepOSelect={sleepOSelect}
                sleepOSelected={this.sleepOChangeHandler}
                sleepChange={this.sleepChangehandler}
                //
                chronicOSelect={chronicOSelect}
                chronicOSelected={this.chronicOChangeHandler}
                mealSelect={mealSelect}
                mealSelected={this.mealsChangeHandler}
                breakfastSelect={breakfastSelect}
                breakfastSelected={this.breakfastChangeHandler}
                fruitSelect={fruitSelect}
                fruitSelected={this.fruitChangeHandler}
                vegetableSelect={vegetableSelect}
                vegetableSelected={this.vegetableChangeHandler}
                sodaSelect={sodaSelect}
                sodaSelected={this.sodaChangeHandler}
                fastFSelect={fastFSelect}
                fastFSelected={this.fastFChangeHandler}
                walking_cyclingSelect={walking_cyclingSelect}
                walking_cyclingSelected={this.walking_cyclingChangeHandler}

                alcoholValue={alcoholState}
                alcoholChange={this.onAlcoholChangeHandler}
                beerChange={this.beerChangeHandler}
                wineChange={this.wineChangeHandler}
                spiritDrinksChange={this.spiritDrinksChangeHandler}

                sistChange={this.sistChangeHandler}
                distChange={this.distChangeHandler}
                pulseChange={this.pulseChangeHandler}
                uricChange={this.uricChangeHandler}
                glucoseChange={this.glucoseChangeHandler}
                colestherolChange={this.colestherolChangeHandler}
                smokers={smokersCenas}
                chronicChange={this.onChronicChangeHandler}
                chronicValue={chronicState}

                //meds
                medChange={this.onMedChangeHandler}
                medValue={medState}
                medsSelect={medsSelect}
                medsSelected={this.medsChangeHandler}
                medsNChange={this.medsNChangeHandler}

                //painV
                painVSelect={painVSelect}
                painVSelected={this.state.painVValue}

                //painL
                painLSelect={painLSelect}
                painLSelected={this.painLChangeHandler}

                //painS
                painSSelect={painSSelect}
                painSSelected={this.painSChangeHandler}

                //painV
                physicalChange={this.onPhysicalChangeHandler}
                physicalValue={physicalState}

                //physical
                physicalVSelect={physicalVSelect}
                physicalVSelected={this.physicalVChangeHandler}
                physicalHSelect={physicalHSelect}
                physicalHSelected={this.physicalHChangeHandler}

                //spirometry
                spiroChange={this.onSpiroChangeHandler}
                spiroValue={spiroState}
                spiroSelected={this.spiroChangeHandler}
                spiroSelect={spiroSelect}

                //visual
                visualChange={this.onVisualChangeHandler}
                visualValue={visualState}
                visualSelected={this.visualChangeHandler}
                visualSelect={visualSelect}

                //auditory
                auditoryChange={this.onAuditoryChangeHandler}
                auditoryValue={auditoryState}
                auditorySelected={this.auditoryChangeHandler}
                auditorySelect={auditorySelect}

                //ecg
                ecgChange={this.onEcgChangeHandler}
                ecgValue={ecgState}
                ecgSelected={this.ecgChangeHandler}
                ecgSelect={ecgSelect}

                //eritogram
                eritrogramChange={this.onEritrogramChangeHandler}
                eritrogramValue={eritrogramState}
                eritrogramSelected={this.eritrogramChangeHandler}
                eritrogramSelect={eritrogramSelect}

                //leukogram
                leukogramChange={this.onLeukogramChangeHandler}
                leukogramValue={leukogramState}
                leukogramSelected={this.leukogramChangeHandler}
                leukogramSelect={leukogramSelect}
                message={message}

                reset = {this.resetForm}
                goBack={this.props.history.goBack}

            />
        )
    }
}

const mapStateToProps = state => {
    return {
        departments: state.fetchRefValues.departments,
        ages: state.fetchRefValues.ageValues,
        genders: state.fetchRefValues.genderValues,
        marital: state.fetchRefValues.maritalValues,
        academic: state.fetchRefValues.academicValues,
        smokersV: state.fetchRefValues.smokerStatusValues,
        smokersF: state.fetchRefValues.smokerFrequencieValues,
        smokersT: state.fetchRefValues.smokersTypeValues,
        smokersA: state.fetchRefValues.smokerNumberValues,
        healthO: state.fetchRefValues.healthOpinionsValues,
        //22-05
        sleepO: state.fetchRefValues.sleepOpinionsValues,
        //
        chronicO: state.fetchRefValues.chronicValues,
        meals: state.fetchRefValues.mealsValues,
        breakfast: state.fetchRefValues.breakfastValues,
        fruits: state.fetchRefValues.fruitValues,
        vegetables: state.fetchRefValues.vegetablesValues,
        sodas: state.fetchRefValues.sodasValues,
        fastF: state.fetchRefValues.fastFoodValues,
        walking_cycling: state.fetchRefValues.walkingCyclingValues,
        meds: state.fetchRefValues.medsValues,
        painV: state.fetchRefValues.painValues,
        painL: state.fetchRefValues.localPainValues,
        painS: state.fetchRefValues.painScaleValues,
        physicalV: state.fetchRefValues.physicalActivityValues,
        physicalH: state.fetchRefValues.physicalHoursValues,
        spiro: state.fetchRefValues.spirometryChangeValues,
        visual: state.fetchRefValues.visualChangeValues,
        auditory: state.fetchRefValues.auditoryChangeValues,
        ecg: state.fetchRefValues.ecgChangeValues,
        eritrogram: state.fetchRefValues.eritrogramChangeValues,
        leukogram: state.fetchRefValues.leukogramChangeValues,
        status: state.admin.status,
        message: state.admin.message,

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onInsertForm: (code, gender, weight, height, department, age, marital, academic, smokersV, smokersF, smokersA, smokersT, healthO, sleepO, sleep, chronicO, meal, breakfast, fruit, vegetables, sodas, fastF, walking_cycling, sist, dist, pulse, uric, glucose, colestherol, meds, medsN, painV, painL, painS, physicalV, physicalH, spiro, visual, auditory, ecg, eritrogram, leukogram, has_chronic, takes_meds, has_physical, spirometry_value, visual_screening_value, auditory_screening_value, ecg_value, eritrogram_value, leukogram_value, alcoholOption, beer, wine, spiritDrinks) =>
            dispatch(actions.insertForm(code, gender, weight, height, department, age, marital, academic, smokersV, smokersF, smokersA, smokersA, healthO, sleepO, sleep, chronicO, meal, breakfast, fruit, vegetables, sodas, fastF, walking_cycling, sist, dist, pulse, uric, glucose, colestherol, meds, medsN, painV, painL, painS, physicalV, physicalH, spiro, visual, auditory, ecg, eritrogram, leukogram, has_chronic, takes_meds, has_physical, spirometry_value, visual_screening_value, auditory_screening_value, ecg_value, eritrogram_value, leukogram_value, alcoholOption, beer, wine, spiritDrinks)),
        onFetchDepartments: () => dispatch(actions.fetchDepartments()),
        onFetchAges: () => dispatch(actions.fetchAgeValues()),
        onFetchGenders: () => dispatch(actions.fetchGenderValues()),
        onFetchMarital: () => dispatch(actions.fetchMaritalValues()),
        onFetchAcademic: () => dispatch(actions.fetchAcademicValues()),
        onFetchSmokersV: () => dispatch(actions.fetchSmokerStatusValues()),
        onFetchSmokersF: () => dispatch(actions.fetchSmokerFrequencieValues()),
        onFetchSmokersA: () => dispatch(actions.fetchSmokerNumberValues()),
        onFetchSmokersT: () => dispatch(actions.fetchSmokerTypeValues()),
        onFetchHealthO: () => dispatch(actions.fetchHealthOpinionsValues()),
        //22-05
        onFetchSleepO: () => dispatch(actions.fetchSleepOpinionsValues()),
        //
        onFetchChronicO: () => dispatch(actions.fetchChronicDiseasesValues()),
        onFetchMeals: () => dispatch(actions.fetchMealsValues()),
        onFetchBreakfast: () => dispatch(actions.fetchBreakfastValues()),
        onFetchFruits: () => dispatch(actions.fetchFruitValues()),
        onFetchVegetables: () => dispatch(actions.fetchVegetablesValues()),
        onFetchSodas: () => dispatch(actions.fetchSodasValues()),
        onFetchFastF: () => dispatch(actions.fetchFastFoodValues()),
        onFetchWalking_cycling: () => dispatch(actions.fetchWalkingCyclingValues()),
        onFetchMeds: () => dispatch(actions.fetchTakesMedsValues()),
        onFetchPainV: () => dispatch(actions.fetchPainValueValues()),
        onFetchPainL: () => dispatch(actions.fetchLocalPainValues()),
        onFetchPainS: () => dispatch(actions.fetchPainScaleValues()),
        onFetchPhysicalV: () => dispatch(actions.fetchPhysicalValues()),
        onFetchPhysicalH: () => dispatch(actions.fetchPhysicalHoursValues()),
        onFetchSpiro: () => dispatch(actions.fetchSpirometryChangeValues()),
        onFetchVisual: () => dispatch(actions.fetchVisualChangeValues()),
        onFetchAuditory: () => dispatch(actions.fetchAuditoryChangeValues()),
        onFetchEcg: () => dispatch(actions.fetchEcgChangeValues()),
        onFetchEritrogram: () => dispatch(actions.fetchEritrogramChangeValues()),
        onFetchLeukogram: () => dispatch(actions.fetchLeukogramChangeValues()),
        inserFormRemoveMessage: () => dispatch(actions.insertFormRemoveMessage())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);



// WEBPACK FOOTER //
// ./src/containers/Admin.js